<template>
  <div id="" class="">
    <el-drawer
      :title="drawerTitle"
      :visible.sync="isShowDrawer"
      direction="rtl"
      :before-close="handleClose">

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>列名</span>
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" style="float: right; padding: 3px 0" @change="handleCheckAllChange">全选</el-checkbox>
        </div>
        <div>
          <el-checkbox-group v-model="checkedHeader" size="medium" @change="handleCheckedChange">
            <el-checkbox v-for="header in headerOptions" :label="header" :key="header">{{header}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>拖拽调整排序</span>
        </div>
        <div>
          <draggable v-model="checkedHeader" animation="300"  style="display: flex;flex-wrap: wrap">
            <div  v-for="(item,index) in checkedHeader" :key="index" class="card-item">
              <el-tag type="danger" >{{ index + 1 }}. {{item}}</el-tag>
            </div>
          </draggable>
        </div>
      </el-card>

      <div style="margin: 10px">
        <el-button @click="saveHeader">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  props:['drawerVisible','title','headerKey','checked','keyToName'],
  watch: {
    drawerVisible(val){
      this.isShowDrawer = val;
    },
    title(val){
      this.drawerTitle = val;
    },
    headerKey(val){
      this.drawerKey = val;
      this.initDrawer()
    },
  },
  data() {
    return {
      isShowDrawer: false,
      drawerTitle: '',
      drawerKey: [],

      checkAll: false,
      checkedHeader: [],
      headerOptions: [],
      isIndeterminate: true
    }
  },
  methods:{
    handleClose(done){
      this.isShowDrawer = false;
      this.$emit('change-state',{isShow: this.isShowDrawer,refresh: false})
      done();
    },

    initDrawer(){
      let list = [];
      this.drawerKey.forEach(item => {
        let i = this.keyToName[item];
        if(i){
          list.push(i);
        }
      })
      this.headerOptions = list;
      this.checkedHeader = this.checked;
    },

    handleCheckAllChange(val) {
      this.checkedHeader = val ? this.headerOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange(value){
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.headerOptions.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.headerOptions.length;
    },

    saveHeader(){
      //console.log(this.checkedHeader);
      this.isShowDrawer = false;
      this.$emit('change-state',{isShow: this.isShowDrawer,refresh: true,newSortList: this.checkedHeader})
    }
  },
}
</script>

<style type="text/css">
.box-card {
  margin: 0 10px 10px 10px;
}
.card-item{
  margin: 0 0 10px 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/drawer/TableHeadDrawer.vue